<template>
  <el-table
    v-loading="$store.state.isLoading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.8)"
    ref="singleTable"
    :data="tabList"
    :height="height"
    highlight-current-row
    :row-class-name="tableRowClassName"
    @current-change="handleCurrentChange"
    border
    style="width: 100%">
    <el-table-column
      v-if="!isno"
      type="index"
      label="序号"
      width="50">
    </el-table-column>
    <el-table-column v-for="(item,index) in columns"
     :sortable="item.sortable"
     :prop="item.field"
     :label="item.title"
     :width="item.width"
     :formatter="item.formatter"
     ></el-table-column>
  </el-table>

</template>

<script>
  export default {
    props:{
      tabList:Array,
      columns:Array,
      isno:Boolean,
      nheight:String

    },
    data() {
      return {
        height:0,
        currentRow: null
      }
    },
    created(){
      if(this.nheight){
        this.height = this.nheight;
      }else{
        this.height = this.$myfn.resetRigthSize();
      }
    },
   mounted: function () {
      this.$nextTick(function () {
        if(this.nheight){
          this.height = this.nheight;
        }else{
          this.height = this.$myfn.resetRigthSize();
        }
      })
    },
    updated:function(){
      if(this.nheight){
        this.height = this.nheight;
      }else{
        this.height = this.$myfn.resetRigthSize();
      }
    },
    methods: {
      tableRowClassName({row, rowIndex}) {
        //console.log(row,rowIndex);
        if(row.maintainStatus === 'X'){
          return "del-row";
        }else{
          return '';
        }
      },
      //选中
      handleCurrentChange(val) {
        this.currentRow = val;
        this.$emit('selectSdata',val);
        //this.$emit("selectSdata");
       //
      },
      handleClick(row) {
        //console.log(row);
      }
    }
  }
</script>
